import { render, staticRenderFns } from "./clientProfileTrainingExamQuestions.vue?vue&type=template&id=1b565705"
import script from "./clientProfileTrainingExamQuestions.vue?vue&type=script&lang=js"
export * from "./clientProfileTrainingExamQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports